import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  quote: null,
};

const quoteSlice = createSlice({
  name: 'quote',
  initialState,
  reducers: {
    setQuote: (state, action) => {
      state.quote = action.payload;
    },
    clearQuote: (state) => {
      state.quote = null;
    },
  },
});

export const { setQuote, clearQuote } = quoteSlice.actions;
export default quoteSlice.reducer;
